import { FiSearch, FiPlus } from "react-icons/fi";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import 'react-toastify/dist/ReactToastify.css';
import { makeRequestAuth } from "../../_config/api";

function AllContactUs() {
    const [contactUs, setContactUs] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const pageSize = 10;
    const maxVisiblePages = 5;

    const [filters, setFilters] = useState({
        keyword: "",
        city: "",
        year: "",
        type: "All",
        month: "All",
    });
    const [contactUsType, setContactUsType] = useState("All");



    const fetchData = async () => {
        try {
            const resData = {
                keyWord: filters.keyword,
                city: filters.city,
                fromDate: "",
                toDate: "",
                status: '',
                sortOrder: "desc",
                sortBy: "createdAt",
                pageNo,
                size: pageSize,
            };

            const response = await makeRequestAuth("post", "/admin/getContactUsList", resData);
            setContactUs(response.data.list || []);
            setTotalCount(response.data.total || 0);
        } catch (error) {
            console.error("Error fetching contactUs:", error);
            showErrorToast("Failed to fetch contactUs. Please try again later.");
            return;

        }

    };

    useEffect(() => {
        fetchData();
    }, [pageNo, filters, contactUsType]);

    const handleStatusChange = async (id, newStatus) => {
        try {
            const response = await makeRequestAuth("post", "/admin/updateContactUsStatus", {
                contactUsId: id,
                status: newStatus,
            });

            const resData = response?.data;

            if (resData?.error) {
                showErrorToast(resData?.error || "Something went wrong");
                return;
            }

            showSuccessToast("Property status updated successfully!");
            fetchData();

        } catch (error) {
            console.error("Error updating property status:", error);

            const errorMessage =
                error?.response?.data?.message.status ||
                error?.response?.data?.message ||
                error?.message ||
                "Failed to update property status. Please try again later.";

            showErrorToast(errorMessage);
        }
    };


    const getPageNumbers = () => {
        const totalPages = Math.ceil(totalCount / pageSize);
        const start = Math.max(1, pageNo - Math.floor(maxVisiblePages / 2));
        const end = Math.min(start + maxVisiblePages - 1, totalPages);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    const totalPages = Math.ceil(totalCount / pageSize);

    return (
        <>
            <div className="p-4 md:p-6 border border-[#434646]/20 dark:border-white/10 rounded-3xl mx-4 shadow-lg dark:bg-[#1A2332]">

                {/* Toast */}
                <ToastContainer position="top-right" autoClose={3000} />

                {/* Header */}
                <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-4 border-b border-[#434646]/20 dark:border-white/10 pb-3">

                    <div>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white">ContactUs</h2>
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                            Total {totalCount}
                        </span>
                    </div>

                    {/* Filters */}
                    <div className="flex flex-wrap w-full lg:w-auto gap-4">

                        {/* Search */}
                        <div className="relative w-full sm:w-44">
                            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

                            <input
                                type="text"
                                placeholder="Search..."
                                value={filters.keyword}
                                onChange={(e) => {
                                    setFilters((f) => ({ ...f, keyword: e.target.value }));
                                    setPageNo(1);
                                }}
                                className="pl-10 pr-4 py-2 border border-[#749EED] bg-white dark:bg-[#1A2332] rounded-xl w-full text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-[#392DFF]"
                            />
                        </div>
                                                {/* City Filter Input */}
                        <div className="relative w-full sm:w-44">
                            <input
                                type="text"
                                placeholder="Filter by City..."
                                value={filters.city}
                                onChange={(e) => {
                                    setFilters((f) => ({ ...f, city: e.target.value }));
                                    setPageNo(1);
                                }}
                                className="px-4 py-2 border border-[#749EED] bg-white dark:bg-[#1A2332] rounded-xl w-full text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-[#392DFF]"
                            />
                        </div>


                    </div>
                </div>

                {/* LIST */}
                <div className="mt-4 flex flex-col gap-4">
                    {contactUs.map((item) => (
                        <div
                            key={item._id}
                            className="flex flex-col gap-4 bg-white dark:bg-[#101726] p-4 rounded-xl border border-gray-200 dark:border-[#434646]/30 shadow-sm"
                        >
                            <div className="flex flex-col md:flex-row justify-between gap-4">

                                {/* LEFT */}
                                <div className="flex flex-col gap-1 flex-grow">
                                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white truncate">
                                        Subject: {item?.subject ?? "-"}
                                    </h3>

                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        Email: {item?.email ?? "-"}
                                    </p>

                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        Name: {item?.name ?? "-"}
                                    </p>

                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        Phone: {item?.phone ?? "-"}
                                    </p>

                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        Location: {item?.location ?? "-"}
                                    </p>


                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        Preferred Time: {item?.message ?? "-"}
                                    </p>
                                </div>

                                {/* RIGHT - STATUS */}
                                <div className="flex flex-col md:items-end min-w-[140px]">
                                    <select
                                        value={item.status}
                                        onChange={(e) => handleStatusChange(item._id, e.target.value)}
                                        className={`px-4 py-2 rounded-md border text-sm font-semibold focus:outline-none
                                        ${item.status === "pending"
                                                ? "bg-yellow-100 border-yellow-500 text-yellow-700"
                                                : item.status === "rejected"
                                                    ? "bg-[#FE4D4D]/10 border-[#FE4D4D] text-[#FE4D4D]"
                                                    : "bg-[#4FFE49]/10 border-[#4FFE49] text-[#4FFE49]"
                                            }
                                    `}
                                    >
                                        <option value="pending">Pending</option>
                                        <option value="approved">Approved</option>
                                        <option value="rejected">Rejected</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 p-2">

                    <div className="text-sm font-bold text-gray-600 dark:text-gray-400">
                        Showing{" "}
                        <span className="font-semibold">
                            {(pageNo - 1) * pageSize + 1}
                        </span>{" "}
                        to{" "}
                        <span className="font-semibold">
                            {Math.min(pageNo * pageSize, totalCount)}
                        </span>{" "}
                        of{" "}
                        <span className="font-semibold">{totalCount}</span>
                    </div>

                    <div className="flex items-center space-x-1">

                        {/* Prev */}
                        <button
                            className="px-3 py-1 rounded bg-[#749EED]/20 hover:bg-[#749EED]/40 disabled:opacity-40"
                            onClick={() => setPageNo((prev) => Math.max(prev - 1, 1))}
                            disabled={pageNo === 1}
                        >
                            &laquo;
                        </button>

                        {/* Pages */}
                        {getPageNumbers().map((page) => (
                            <button
                                key={page}
                                onClick={() => setPageNo(page)}
                                className={`px-3 py-1 rounded text-sm font-semibold
                                ${page === pageNo
                                        ? "bg-[#392DFF] text-white"
                                        : "bg-[#749EED]/20 text-gray-700 dark:text-gray-300 hover:bg-[#749EED]/40"
                                    }
                            `}
                            >
                                {page}
                            </button>
                        ))}

                        {/* Next */}
                        <button
                            className="px-3 py-1 rounded bg-[#749EED]/20 hover:bg-[#749EED]/40 disabled:opacity-40"
                            onClick={() => setPageNo((prev) => Math.min(prev + 1, totalPages))}
                            disabled={pageNo === totalPages}
                        >
                            &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AllContactUs;
